import config from './_config'

let colors = new Array(...config.colors)

export const makeColor = () => {
    if (colors.length == 0) {
        colors = new Array(...config.colors)
    }

    const colorIndex = Math.floor(Math.random() * colors.length)
    const color = colors[colorIndex]
    colors.splice(colorIndex, 1);
    return color;
}